<script lang="ts" setup>
  import { ref } from 'vue';

  defineProps({
    isCartEmpty: { type: Boolean, required: true },
  });

  const open = ref(false);
</script>
<template>
  <SfButton :disabled="isCartEmpty" small transparent @click="open = true" aria-controls="cart-wishlist-modal">
    <template #before>
      <SfIconHeart aria-hidden="true" />
    </template>
    <template #default>
      {{ $t('SHOP.CART.ACTION.ADD_CART_TO_WISHLIST') }}
    </template>
  </SfButton>
  <UiModal medium v-model:open="open" id="cart-wishlist-modal" aria-labelledby="cart-wishlist-heading">
    <SfModalHeader v-model:open="open" headingId="cart-wishlist-heading">
      {{ $t('SHOP.CART.HEADER.ADD_CART_TO_WISHLIST') }}
    </SfModalHeader>
    <CartWishlistPickerModal @saved="open = false" />
  </UiModal>
</template>
